// src/frontend.js

window.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.protected-block form').forEach((form) => {
        const container = form.closest('.protected-block');
        const msgDiv = container.querySelector('.block-message');
        const blockId = form.getAttribute('data-block-id');
        const correctHash = form.getAttribute('data-hash');
        const errorText = form.getAttribute('data-error');

        if (document.cookie.includes(`${blockId}=1`)) {
            container.innerHTML = '';
        } else {
            const params = new URLSearchParams(window.location.search);
            const pw = params.get('pw');
            if (pw) {
                crypto.subtle.digest("SHA-256", new TextEncoder().encode(pw)).then(buffer => {
                    const hash = Array.from(new Uint8Array(buffer)).map(b => b.toString(16).padStart(2, "0")).join("");
                    if (hash === correctHash) {
                        document.cookie = `${blockId}=1; path=/; max-age=3600`;
                        location.reload();
                    } else {
                        msgDiv.textContent = errorText;
                        msgDiv.style.color = 'red';
                    }
                });
            }
        }

        form.addEventListener('submit', async function (e) {
            e.preventDefault();
            const pw = form.pw.value;
            const buffer = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(pw));
            const hash = Array.from(new Uint8Array(buffer)).map(b => b.toString(16).padStart(2, "0")).join("");

            if (hash === correctHash) {
                document.cookie = `${blockId}=1; path=/; max-age=3600`;
                location.reload();
            } else {
                msgDiv.textContent = errorText;
                msgDiv.style.color = 'red';
            }
        });
    });
});
